/* assets/charm_bar.js */
(function () {
  // ---------- Global Charms Staging (one singleton for the whole page) ----------
  // Exposed API:
  //  - CIKB.stageBundle({ id, items:[{id,quantity,properties}], display:[{title,img,oos}], meta:{bid,...} })
  //  - CIKB.getStagedLineItems(pop=false) -> flat items[]
  //  - CIKB.peekLineItems() -> flat items[] (non-destructive)
  //  - CIKB.getStagedBundles() -> all bundles[]
  //  - CIKB.removeBundle(id)
  //  - CIKB.restageLineItems(items, meta) -> put items back after a failed add
  // Events:
  //  - document: 'cikb:staged:change'  detail: { staged: bundles[] }

  // One-time style override: keep preorder text red, and DO NOT gray out keys/images for preorder
  // Sold-out keys (continue selling OFF) get grayed out and blocked
  (function injectOnce(){
    if (document.getElementById('cikb-preorder-style')) return;
    const style = document.createElement('style');
    style.id = 'cikb-preorder-style';
    style.textContent = `
      .cikb-key--oos { opacity: 1 !important; text-decoration: none !important; }
      .cikb-key--oos .cikb-key__img { filter: drop-shadow(0 2px 4px rgba(0,0,0,.15)) !important; }
      .cikb-key__preorder, .cikb-staged__note { color:#EA6739 !important; }
      .cikb-key--soldout { opacity: .45 !important; cursor: not-allowed !important; pointer-events: auto !important; }
      .cikb-key--soldout .cikb-key__img { filter: grayscale(.6) opacity(.5) !important; }
      .cikb-key__soldout { font-size:11px; line-height:1.1; font-weight:800; color:#999; }
    `;
    document.head.appendChild(style);
  })();

  /* Declared ABOVE boot(). These are const, and boot() runs further down this same
   * IIFE — on an already-loaded document it calls initBlock synchronously, which
   * reaches __swatchStyle and read them in their temporal dead zone. Function
   * declarations hoist; const does not. */
  /* Stand-ins for the colourways that ship no flat colour, matching the map cart-item.liquid
   * appends so the PDP and the cart cannot disagree. Sky/Green is a two-tone and reads as
   * its green half. */
  const STANDIN = { 'CHERIE': '#bae3f4', 'LA LUNE': '#1c1d33', 'SKY/GREEN': '#1ab87b' };
  /* Two-tone: there is no strap tile for it and tiling the split-circle chip produced
   * vertical stripes. It renders as the solid. */
  const NO_PATTERN = { 'SKY/GREEN': 1 };

  /* The theme's asset directory, taken from a file we know is loaded from it. */
  window.CIKB = window.CIKB || (() => {
    const staged = [];
    const emit = () => {
      document.dispatchEvent(new CustomEvent('cikb:staged:change', {
        detail: { staged: staged.map(b => ({ ...b, items: b.items.slice(), display: (b.display||[]).slice() })) }
      }));
    };

    return {
      stageBundle(bundle) {
        if (!bundle || !Array.isArray(bundle.items) || !bundle.items.length) return;
        staged.push(bundle);
        emit();
      },
      getStagedLineItems(pop = false) {
        const items = staged.flatMap(b => b.items);
        if (pop) { staged.length = 0; emit(); }
        return items;
      },
      peekLineItems() {
        return staged.flatMap(b => b.items);
      },
      getStagedBundles() {
        return staged.map(b => ({ ...b, items: b.items.slice(), display: (b.display||[]).slice() }));
      },
      removeBundle(id) {
        const i = staged.findIndex(b => b.id === id);
        if (i > -1) { staged.splice(i, 1); emit(); }
      },
      /* Replace IN PLACE. Position is meaningful: staged set N is worn by unit N of a
       * quantity bundle, so a saved edit that removed and re-pushed sent set 1 to the end
       * and swapped its colour with set 2. */
      replaceBundle(id, bundle) {
        if (!bundle) return false;
        const i = staged.findIndex(b => b.id === id);
        if (i < 0) { staged.push(bundle); emit(); return false; }
        staged.splice(i, 1, bundle);
        emit();
        return true;
      },
      /* The strap style for staged set N, so the cart can paint each set in its own colour.
       * Exposed because buy-buttons stamps the properties and lives in another file. */
      strapStyleForSet(index) {
        try { return stagedStrapStyle(index) || null; } catch (e) { return null; }
      },
      restageLineItems(items = [], meta = {}) {
        if (!Array.isArray(items) || !items.length) return;
        const id = (meta.id) || (crypto?.randomUUID?.() || String(Date.now()));
        staged.push({ id, items: items.map(x => ({...x})), display: meta.display || [], meta });
        emit();
      }
    };
  })();

  // ---------- Boot across theme lifecycle events ----------
  const START_EVENTS = ["DOMContentLoaded", "shopify:section:load", "shopify:section:select"];
  START_EVENTS.forEach(evt => document.addEventListener(evt, () => boot()));
  if (document.readyState !== "loading") boot();

  function boot() {
    document.querySelectorAll('.cikb[data-bid]').forEach(root => initBlock(root));
  }

  // ---------------- helpers ----------------
  function getPayload(bid) {
    const node = document.getElementById(`cikb-payload-${bid}`);
    if (!node) return {};
    try { return JSON.parse(node.textContent || "{}"); } catch { return {}; }
  }

  const uuid = () =>
    (window.crypto?.randomUUID?.() ||
      "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
        const r = Math.random()*16|0, v = c === "x" ? r : (r&0x3|0x8);
        return v.toString(16);
      }));

  const toast = (m) => { try { window?.Shopify?.toast?.show?.(m); } catch {} };

  // Parse a number like "$3", "3", "3.00" out of the price note (used for staged total)
  function parsePricePerCharm(note, fallback = 3) {
    if (typeof note !== "string") return fallback;
    const m = note.replace(',', '.').match(/([0-9]+(?:\.[0-9]{1,2})?)/);
    return m ? parseFloat(m[1]) : fallback;
  }


  /* Shop-currency amounts formatted with the shopper's currency code read as the wrong
   * number: a $3 charm came out as "A$3.00" for an Australian shopper whose real price is
   * about A$4.28. Every figure here comes from Liquid in the shop's currency, so convert
   * with the rate Shopify publishes for the active market before formatting. */
  function __presentmentRate() {
    try {
      const r = parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || "1");
      return isFinite(r) && r > 0 ? r : 1;
    } catch (e) { return 1; }
  }
  function moneyFmt(n) {
    try {
      const locale = document.documentElement.lang || "en-US";
      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: (window.Shopify?.currency?.active || "USD")
      }).format((Number(n) || 0) * __presentmentRate());
    } catch {
      return `$${(+n || 0).toFixed(2)}`;
    }
  }

  // Create a staged area container under the trigger if missing
  function ensureStagedContainer(root, bid) {
    const btn = root.querySelector(`#cikb-open-${bid}`);
    if (!btn) return null;

    let wrap = root.querySelector('.cikb-staged-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'cikb-staged-wrap';
      wrap.innerHTML = `
        <style>
          #cikb-${bid} .cikb-staged-wrap{margin:12px 0 6px}
          #cikb-${bid} .cikb-staged__list{display:grid; gap:10px}
          /* wrap + shrinkable band: the row has four flex children (band, meta, Edit,
             Delete) and none of them could shrink, so an eight-charm band measured 573px
             inside a 358px column on a 390px phone and pushed Edit and Delete clean off
             the screen where they could not be tapped. The band gives way first; the two
             buttons never shrink and never move. */
          #cikb-${bid} .cikb-staged__item{display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:10px; border:1px solid var(--cikb-border, rgba(0,0,0,.08)); border-radius:12px; padding:10px 12px; background:var(--cikb-card,#fff);}
          #cikb-${bid} .cikb-staged__rm{flex:0 0 auto}
          /* The staged set reads as charms ON the collar, not as a row of tiles — same
             shape the cart uses. The band takes the colour or the printed artwork of the
             collar the customer has actually selected, and the charms sit proud of it. */
          #cikb-${bid} .cikb-staged__thumbs{display:flex; gap:0; align-items:center; flex-wrap:nowrap;
            height:34px; box-sizing:border-box; padding:0 16px; border-radius:999px;
            background:var(--cikb-staged-strap, #fff); background-size:cover; background-position:center;
            border:1px solid rgba(0,0,0,.12);
            /* min-width:0 is what actually lets a flex item shrink below its content;
               without it the band keeps its natural width no matter what flex-basis says.
               Charms past the edge scroll rather than widening the row. */
            min-width:0; flex:1 1 200px; max-width:100%; overflow-x:auto; overflow-y:hidden;
            scrollbar-width:none}
          #cikb-${bid} .cikb-staged__thumbs::-webkit-scrollbar{display:none}
          /* On a phone, squeezing band + title + price + two buttons onto one line leaves
             the title clipped to "Ch..." and the price broken over four lines. Give the
             band the full first row and let the meta and both buttons share the second. */
          @media (max-width: 600px){
            #cikb-${bid} .cikb-staged__item{row-gap:8px}
            #cikb-${bid} .cikb-staged__thumbs{flex:1 1 100%; max-width:100%}
            #cikb-${bid} .cikb-staged__meta{flex:1 1 auto}
          }
          #cikb-${bid} .cikb-staged__thumb{width:44px; height:44px; border-radius:0; border:0;
            background:none; overflow:visible; display:grid; place-items:center; flex:0 0 auto;
            /* Was -7px a side, i.e. 14px of overlap between neighbours. The pull-in was
               meant to close the transparent padding in a 44px charm PNG, but the silicone
               art is wider than the letter inside it, so on an eight-charm strap the shapes
               visibly collided. A small positive gap instead: no overlap, and the strip
               still reads as charms threaded on one band. */
            margin:0 1px;
            filter:drop-shadow(0 1px 2px rgba(0,0,0,.20))}
          #cikb-${bid} .cikb-staged__thumb img{max-width:100%; max-height:100%; object-fit:contain}
          #cikb-${bid} .cikb-staged__meta{display:flex; flex-direction:column; gap:6px; flex:1; min-width:0}
          #cikb-${bid} .cikb-staged__title{font-weight:800; font-size:13px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis}
          #cikb-${bid} .cikb-staged__price{font-size:13px; opacity:.85}
          #cikb-${bid} .cikb-staged__rm{border:1px solid var(--cikb-border, rgba(0,0,0,.12)); background:#fff; border-radius:999px; padding:6px 10px; cursor:pointer}
          #cikb-${bid} .cikb-staged__note{font-size:12px; font-weight:800;}
        </style>
        <div class="cikb-staged__list" id="cikb-staged-${bid}"></div>
      `;
      btn.insertAdjacentElement('afterend', wrap);
    }
    return wrap.querySelector(`#cikb-staged-${bid}`);
  }

  /* Paint the staged band to match the selected collar.
   *
   * Read the ACTIVE swatch rather than a checked radio: every variant radio on the page
   * shares name="id" and submits a whole variant, so only one is ever checked and after a
   * size click that one is a size. The bundle builder marks its own choice with .is-active.
   *
   * Printed colourways (Cherie, La Lune) cannot be represented by a hex, so the same
   * strap_colors overrides the inline builder uses are honoured here, and tiled rather
   * than stretched so the dots stay round — matching the cart strip. */
  /* Which product are the charms actually ON?
   *
   * A collar on the collar and walk sets — but the bottle bundle hangs them from a
   * silicone charm strap, and there this took the first colour row on the page, which is
   * the bottle: the band went Baby Pink while the strap was Butter.
   *
   * Collar first where the set has one — that is the strap the charms sit on and the
   * colour the customer thinks of as the set's. Only then the charm strap, for bundles
   * like the bottle that have no collar at all, then a shared colour row, then first. */
  /* The units this page's product is actually being bought in, in order.
   *
   * A quantity bundle is several of ONE product in several colours, so there is no single
   * band colour — staged charm set N belongs to unit N. The free rows pick their colour
   * from a <select> rather than a swatch, so resolve those through any swatch carrying the
   * same label; every row offers the same set. A plain PDP has one unit, the theme's own
   * selected swatch, which is what the collar page needs. */
  function __unitSwatches() {
    /* Only the OPEN tier. A collapsed tier is not what is being bought, and the "Buy 1"
      * tier renders no unit rows at all — so it falls through to the product's own colour
      * selector below, which is exactly what a single unit should follow. */
    const tier = document.querySelector('.mqb__tier.is-selected');
    if (tier) {
      const rows = Array.prototype.slice.call(tier.querySelectorAll('.mqb__unit, .mqb__free'));
      const out = rows.map((row) => {
        const active = row.querySelector('.mqb__swatch.is-active');
        if (active) return active;
        const sel = row.querySelector('select.mqb__free-select');
        if (!sel) return null;
        const want = (sel.options[sel.selectedIndex] || {}).textContent || '';
        return tier.querySelector('.mqb__swatch[aria-label="' + String(want).trim().replace(/"/g, '\\"') + '"]');
      }).filter(Boolean);
      if (out.length) return out;
    }
    /* A plain PDP: this product's own colour picker. Scope it — the page is full of
     * product cards that carry .swatch too, and a bare document query took the first one
     * it found, which painted the band whatever colour some card in a carousel happened
     * to be. Only the option-group swatches belong to the product being bought. */
    /* One option, TWO rendered groups: "Color" and "Limited Edition" are both the colour
     * axis. Walking the groups in order and taking the first with a marked swatch returned
     * the Color group's stale highlight whenever a Limited Edition colour was chosen — so
     * picking Cherie, La Lune or Sky/Green painted the band Lilac. The checked radio is the
     * only thing that says which variant is actually selected, so look for it across EVERY
     * group before falling back to a highlight. */
    const scope = document.querySelector('[js-product-section]') || document;
    const groups = Array.from(scope.querySelectorAll('.option-group__swatches-container'));
    for (const g of groups) {
      const checked = g.querySelector('input[js-variant-input]:checked');
      const viaRadio = checked && checked.closest('label') &&
                       checked.closest('label').querySelector('.swatch[aria-label]');
      if (viaRadio) return [viaRadio];
    }
    for (const g of groups) {
      const marked = g.querySelector('.swatch--selected[aria-label]');
      if (marked) return [marked];
    }
    return [];
  }

  /* Every colour this product is actually sold in, as the nodes of whichever picker the
   * page has. The modal's own row was a static list of seven hexes from the block settings,
   * so the printed colourways and every limited edition were missing — and a colour the row
   * does not carry cannot be previewed, matched, or sent back to the PDP. */
  function __pageColourSwatches() {
    const mqb = document.querySelector('.mqb__tier.is-selected .mqb__swatches');
    if (mqb) {
      const n = mqb.querySelectorAll('.mqb__swatch[aria-label]');
      if (n.length) return Array.from(n);
    }
    const mpb = document.querySelector('.mpb-card[data-is-collar="true"] .mpb-opt--color') ||
                document.querySelector('.mpb-opt--color');
    if (mpb) {
      const n = mpb.querySelectorAll('.mpb-swatch[aria-label]');
      if (n.length) return Array.from(n);
    }
    const scope = document.querySelector('[js-product-section]') || document;
    const out = [];
    scope.querySelectorAll('.option-group__swatches-container').forEach((g) => {
      g.querySelectorAll('.swatch[aria-label]').forEach((n) => out.push(n));
    });
    return out;
  }

  /* What a swatch MEANS, in one place.
   *
   * Every consumer — the staged band, the modal preview, the cart hand-off — has to agree,
   * and duplicating this rule is exactly what broke: the band read Blueberry's flat hex
   * while the modal tiled Blueberry's 96px product photo, which is mostly white, so the
   * strap came up blank beside a correctly highlighted pill.
   *
   * A flat colour always wins. Only the printed colourways (Cherie, La Lune, Sky/Green)
   * ship no colour at all, and for those the artwork IS the colour. */
  function __assetBase() {
    const n = document.querySelector('script[src*="/assets/charm_bar.js"]') ||
              document.querySelector('link[href*="/assets/"]');
    const u = n ? (n.src || n.href || '') : '';
    const i = u.indexOf('/assets/');
    return i > -1 ? u.slice(0, i + 8) : '';
  }

  /* The strap treatment for a colourway that ships no flat colour: the purpose-made tile
   * where the theme has one, and a representative solid to stand behind it (and to stand
   * alone for the two-tone, which has no tile). */
  function __printedStyle(label, key) {
    const solid = STANDIN[key] || '';
    const base = __assetBase();
    const handle = String(label).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const pattern = (base && handle && !NO_PATTERN[key])
      ? base + 'collar-pattern-' + handle + '.png' : '';
    return (solid || pattern) ? { color: solid, image: pattern, tile: 'pattern' } : null;
  }

  function __swatchStyle(node) {
    if (!node) return null;
    const label = (node.getAttribute('aria-label') || node.getAttribute('data-label') || '').trim();
    const fill = node.querySelector('.mpb-swatch__fill') ||
                 node.querySelector('.swatch__inner') || node;
    const cs = getComputedStyle(fill);
    const bg = cs.backgroundColor;
    const colour = bg && bg !== 'rgba(0, 0, 0, 0)' ? bg : '';
    const key = label.toUpperCase();
    /* A purpose-cut repeat tile beats the flat hex. STANDIN only lists the colourways that
     * ship NO colour at all, so a printed colourway that also has a hex — every Mediterranean
     * one does — fell straight through to the `colour` branch below and returned image:''.
     * That is why Milos and Valencia painted as a flat band on the staged strip and in the
     * cart while the modal tiled them correctly. Marking it 'pattern' is what lets it travel:
     * publishStrapToCart only forwards a tile tagged that way. */
    const cikbTile = (window.CIKB_STRAP_TILES || {})[label.toLowerCase()];
    if (cikbTile) return { color: colour || '', image: cikbTile, tile: 'repeat' };
    /* A printed or two-tone colourway is defined by its ARTWORK, never by whatever its
     * swatch element computes to. The set builder paints a grey #eee placeholder behind the
     * artwork, which is a perfectly real background-color — so trusting the colour first
     * meant Cherie, La Lune and Sky/Green all resolved to grey on set pages and the strap
     * came up blank. Check the known stand-ins by label before the computed colour. */
    if (STANDIN[key]) return __printedStyle(label, key);
    if (colour) return { color: colour, image: '', tile: '' };
    /* No flat colour means a printed or two-tone colourway, and the 96px swatch is a PHOTO
     * OF A CIRCLE — tiling it left seams on the dots and turned the two-tone into stripes.
     * Prefer the purpose-made strap tile where the theme ships one (cherie, la-lune), and a
     * representative solid otherwise. */
    if (STANDIN[key]) return __printedStyle(label, key);
    const m = String(cs.backgroundImage || '').match(/url\((['"]?)(.*?)\1\)/);
    if (m && m[2]) return { color: '', image: m[2], tile: 'swatch' };
    return null;
  }

  function __bandSwatch(index) {
    /* A quantity bundle owns the colours: charm set N sits on unit N, so ask the units
     * FIRST. Every branch below ignores `index` — they answer "the one colour this page
     * is wearing" — so on a leash PDP, which has both a product colour row and a quantity
     * bundle, set 2 was painted unit 1's colour and the customer saw the wrong strap the
     * moment they opened the builder a second time. Only take this path when the open tier
     * really renders unit rows; MPB pages and plain PDPs still fall through. */
    const mqbTier = document.querySelector('.mqb__tier.is-selected');
    if (mqbTier && mqbTier.querySelector('.mqb__unit, .mqb__free')) {
      const tierUnits = __unitSwatches();
      if (tierUnits.length) {
        const n = Number(index);
        return tierUnits[(Number.isFinite(n) && n >= 0 ? n : 0) % tierUnits.length];
      }
    }
    const cards = Array.prototype.slice.call(document.querySelectorAll('.mpb-card'));
    const collar = document.querySelector('.mpb-card[data-is-collar="true"] .mpb-swatch.is-active');
    if (collar) return collar;
    const strapCard = cards.filter(function (c) {
      return /charm[-_ ]?strap|strap/i.test(c.dataset.handle || '') ||
             /charm[-_ ]?strap/i.test(c.textContent || '');
    })[0];
    if (strapCard) {
      const s = strapCard.querySelector('.mpb-swatch.is-active');
      if (s) return s;
    }
    const shared = document.querySelector('.mpb-shared-color .mpb-swatch.is-active') ||
                   document.querySelector('.mpb-opt--color .mpb-swatch.is-active');
    if (shared) return shared;
    /* No bundle builder on the page: a quantity bundle or a plain PDP. Charm set N sits on
     * unit N, and repeats from the start once there are more charm sets than units. */
    const units = __unitSwatches();
    if (!units.length) return null;
    const i = Number(index);
    return units[(Number.isFinite(i) && i >= 0 ? i : 0) % units.length];
  }

  function stagedStrapStyle(index) {
    /* The band is the COLLAR's webbing, so read the collar's own swatch. With independent
     * colours there are several colour rows and a bare querySelector takes the first, which
     * is the leash — the band then showed a colour the customer had not chosen for it.
     * Fall back to the shared row, then to any row, for the templates that link colours. */
    const sw = __bandSwatch(index);
    if (!sw) return null;
    const label = (sw.getAttribute('aria-label') || '').trim().toLowerCase();
    const raw = (document.querySelector('[data-strap-colors]') || {}).dataset?.strapColors || '';
    let override = '';
    raw.split(/[\r\n]+/).forEach((line) => {
      const i = line.indexOf('|');
      if (i < 0) return;
      if (line.slice(0, i).trim().toLowerCase() === label) override = line.slice(i + 1).trim();
    });
    /* Each picker keeps its colour on a different node: MPB on a fill span, the theme's
     * own swatch on .swatch__inner, MQB straight on the button. */
    const resolved = __swatchStyle(sw) || {};
    const colour = resolved.color || '';
    const swatchImg = resolved.image || '';
    /* Return both. The band prefers the artwork, but the cart still wants a hex to stand
     * behind it while the image loads and if it 404s. */
    if (override && !/^(#|rgb|hsl)/i.test(override)) return { image: override, color: colour, tile: 'pattern' };
    if (override) return { color: override };
    /* Hand back what the resolver decided, INTACT.
     *
     * This used to rebuild the answer as `{ color }` whenever a colour existed, which threw
     * away the strap tile that came with it: Cherie resolves to its stand-in AND its stripe
     * artwork, and only the stand-in survived — so the band painted flat pale blue while the
     * tile it had already fetched sat unused. */
    if (colour || swatchImg) {
      return { color: colour, image: swatchImg, tile: resolved.tile || (swatchImg ? 'swatch' : '') };
    }
    return null;
  }

  function paintStagedStrap(el, index) {
    const st = stagedStrapStyle(index != null ? index : (el && el.dataset ? el.dataset.unitIndex : undefined));
    if (!el || !st) return;
    if (st.image) {
      const h = el.getBoundingClientRect().height || 34;
      /* 'repeat' is a true repeat unit cut from the artwork (Valencia 1.05:1, Milos 3.42:1),
       * so its natural aspect IS the printed one. Forcing it through the webbing ratio below
       * squashed Milos's wave to a 17.7px sliver. */
      const size = (st.tile === 'swatch' || st.tile === 'repeat')
        ? 'auto 100%'
        /* A strap tile is 13.07mm by 25.05mm, so one tile is 0.52 of the height wide. */
        : (h * 0.5217).toFixed(1) + 'px ' + h.toFixed(1) + 'px';
      /* Most colours ship no strap tile, so the solid stands until the artwork proves it
       * loads. Painting first and probing after is what stops a 404 leaving a blank band. */
      el.style.backgroundImage = '';
      el.style.setProperty('--cikb-staged-strap', st.color || 'transparent');
      const probe = new Image();
      probe.onload = function () {
        el.style.backgroundImage = 'url("' + st.image + '")';
        el.style.backgroundRepeat = 'repeat-x';
        el.style.backgroundSize = size;
        el.style.setProperty('--cikb-staged-strap', 'transparent');
      };
      probe.src = st.image;
    } else {
      el.style.backgroundImage = '';
      el.style.backgroundRepeat = '';
      el.style.setProperty('--cikb-staged-strap', st.color);
    }
  }

  /* Repaint every staged band from its own unit. A quantity bundle changes one row at a
   * time, so a single band colour is never enough — each staged set has to be re-read. */
  function repaintAllStagedStraps(scope) {
    (scope || document).querySelectorAll('.cikb-staged__thumbs').forEach((el, i) => {
      const idx = el.dataset && el.dataset.unitIndex != null ? Number(el.dataset.unitIndex) : i;
      paintStagedStrap(el, idx);
    });
  }

  /* The charms of a staged set, ready to load back into the editor. Newly staged sets
   * carry the working strap on their meta; anything staged before that is rebuilt from the
   * line items and display data, which are written in the same order. */
  function rebuildStrap(b) {
    const saved = b && b.meta && b.meta.strap;
    if (Array.isArray(saved) && saved.length) return saved.map((x) => ({ ...x }));
    const items = (b && b.items) || [];
    const disp = (b && b.display) || [];
    if (!items.length) return null;
    return items.map((it, i) => ({
      variantId: it.id,
      freeVariantId: (it.properties && it.properties._FreeCharm === '1') ? it.id : null,
      title: (disp[i] && disp[i].title) || (it.properties && it.properties._Letter) || '',
      img: (disp[i] && disp[i].img) || '',
      oos: !!(disp[i] && disp[i].oos)
    }));
  }

  // Render all staged bundles for THIS block (filtered by meta.bid)
  function renderStagedList(root, bid, DATA) {
    const list = ensureStagedContainer(root, bid);
    if (!list) return;

    const all = window.CIKB.getStagedBundles();
    const stagedForThisBlock = all.filter(b => String(b?.meta?.bid) === String(bid));
    list.innerHTML = '';

    stagedForThisBlock.forEach((bundle, bIdx) => {
      const li = document.createElement('div');
      li.className = 'cikb-staged__item';
      li.dataset.stagedId = bundle.id;

      // thumbs
      const thumbs = document.createElement('div');
      thumbs.className = 'cikb-staged__thumbs';
      /* Keep the unit this set belongs to on the node: the repaint handlers below run long
       * after this loop and have no other way back to the position. */
      thumbs.dataset.unitIndex = String(bIdx);
      setTimeout(() => paintStagedStrap(thumbs, bIdx), 0);
      (bundle.display || []).forEach(ch => {
        const t = document.createElement('div');
        t.className = 'cikb-staged__thumb';
        if (ch.img) {
          t.innerHTML = `<img src="${ch.img}" alt="${ch.title || ''}">`;
        } else {
          const c = (ch.title || '').slice(0,1).toUpperCase();
          t.textContent = c || '•';
        }
        thumbs.appendChild(t);
      });

      // meta (title + price + optional preorder note BELOW thumbs on its own line)
      const meta = document.createElement('div');
      meta.className = 'cikb-staged__meta';

      const title = document.createElement('div');
      title.className = 'cikb-staged__title';
      const count = (bundle.items || []).length;
      const label = (DATA?.ui?.addLabel || 'ADD TO SET').replace(/ADD TO SET/i, 'Charms');
      title.textContent = `${label} — ${count} charm${count===1?'':'s'}`;

      const price = document.createElement('div');
      price.className = 'cikb-staged__price';
      const per = parsePricePerCharm(DATA?.ui?.priceNote, 3);
      price.textContent = `${moneyFmt(per)} × ${count} = ${moneyFmt(per * count)}`;

      meta.append(title, price);

      const anyOOS = (bundle.display || []).some(d => d && d.oos === true);
      if (anyOOS) {
        const pre = document.createElement('div');
        pre.className = 'cikb-staged__note';
        pre.textContent = DATA?.ui?.oosPreorderNote || " ";
        meta.appendChild(pre); // <<— new line under charms images (meta is under thumbs)
      }

      /* Edit this set. A multi-set block's trigger adds a NEW set — which is what it
       * should do — so the staged row is the only place an edit can live. */
      let ed = null;
      if (rebuildStrap(bundle)) {
        ed = document.createElement('button');
        ed.type = 'button';
        ed.className = 'cikb-staged__rm cikb-staged__edit';
        ed.textContent = 'Edit';
        ed.addEventListener('click', () => {
          if (typeof root.__cikbEditBundle === 'function') root.__cikbEditBundle(bundle.id);
        });
      }

      // remove
      const rm = document.createElement('button');
      rm.type = 'button';
      rm.className = 'cikb-staged__rm';
      rm.textContent = 'Delete';
      rm.addEventListener('click', () => {
        window.CIKB.removeBundle(bundle.id);
      });

      if (ed) li.append(thumbs, meta, ed, rm); else li.append(thumbs, meta, rm);
      list.appendChild(li);
    });

    /* One set only, where the block asks for it. The set builder sells a single collar,
     * so a second set of charms has nothing to go on — and the running total and the
     * cart bundle both assume one. Keep the newest and drop the rest, which also turns
     * the trigger into an edit: reopen, pick again, the old set is replaced. */
    if (String(root.dataset.singleSet || "") === "true" && stagedForThisBlock.length > 1) {
      stagedForThisBlock.slice(0, -1).forEach((b) => {
        try { window.CIKB.removeBundle(b.id); } catch (e) {}
      });
      return renderStagedList(root, bid, DATA);
    }

    // Update trigger label when at least one staged
    const openBtn = root.querySelector(`#cikb-open-${bid}`);
    if (openBtn) {
      if (stagedForThisBlock.length > 0) {
        openBtn.textContent = DATA?.ui?.btnHasStaged || 'ADD ANOTHER SET OF CHARMS';
      } else {
        openBtn.textContent = DATA?.ui?.btnDefault || (DATA?.ui?.heading || 'ADD CHARM PERSONALIZATION');
      }
    }
  }

  /* Keep the PDP's charm selection after Add to cart.
   *
   * Adding CONSUMES the staged bundle — getStagedLineItems(pop) empties the store, which
   * is right for a page where each add is a fresh set. On the set builder the block is
   * configured for a single set and reads as a persistent configuration, so the page went
   * blank right after the customer had built something and the trigger flipped back from
   * "Edit charms" to the empty state.
   *
   * Snapshot on every change and restore after a successful add, but only for blocks that
   * asked for a single set — the walk-set and collar builders keep clearing, which is the
   * behaviour they were written for. Restoring re-stages, so a second Add to cart adds the
   * set again, exactly as if the customer had rebuilt it. */
  const __lastStaged = new Map();   // bid -> bundles[]
  document.addEventListener('cikb:staged:change', (e) => {
    const staged = (e.detail && e.detail.staged) || [];
    const byBid = new Map();
    staged.forEach((b) => {
      const bid = String(b?.meta?.bid || '');
      if (!bid) return;
      if (!byBid.has(bid)) byBid.set(bid, []);
      byBid.get(bid).push(b);
    });
    /* Remember EMPTY too.
     *
     * This bailed on an empty list and otherwise wrote only the bids that still had
     * bundles, so deleting a set never un-remembered it. The post-add restore then put the
     * deleted set back on screen while the cart — correctly — had no charms in it: the UI
     * claimed charms the customer was not being charged for. Record every block on the
     * page, including the ones that now hold nothing. */
    document.querySelectorAll('.cikb[data-bid]').forEach((root) => {
      const bid = String(root.dataset.bid || '');
      if (bid) __lastStaged.set(bid, byBid.get(bid) || []);
    });
    byBid.forEach((v, k) => { if (!__lastStaged.has(k)) __lastStaged.set(k, v); });
  });

  /* A quantity-bundle tier change re-colours the units: "Buy 2, Get 1" and "Buy 3, Get 2"
   * carry their own per-unit selections, so a strap staged under one tier is wearing a
   * colour that is no longer on screen once the customer switches. mqb.js dispatches no
   * event of its own, so watch the block for interaction and repaint after it settles.
   * repaintAllStagedStraps re-reads the units, so this needs no state of its own. */
  document.addEventListener('click', (e) => {
    try {
      const t = e.target;
      if (!t || typeof t.closest !== 'function' || !t.closest('.mqb')) return;
      setTimeout(() => { try { repaintAllStagedStraps(); } catch (err) {} }, 120);
      setTimeout(() => { try { repaintAllStagedStraps(); } catch (err) {} }, 420);
    } catch (err) {}
  }, true);

  document.addEventListener('sp:staged:consumed', (ev) => {
    /* Prefer what the add-to-cart actually consumed. The local snapshot is refreshed on
     * every staged:change, and the pop performed by the add is itself a change — so the
     * snapshot is empty by the time we get here and nothing was ever restored on a
     * multi-set block. Fall back to the snapshot for callers that send no detail. */
    const consumed = (ev && ev.detail && Array.isArray(ev.detail.bundles))
      ? ev.detail.bundles : null;
    document.querySelectorAll('.cikb[data-bid]').forEach((root) => {
      /* Restore for EVERY block, not just single-set ones.
       *
       * This was gated on data-single-set === 'true', so on a quantity bundle — which is
       * multi-set by definition, and where the customer may have configured a set per unit
       * — adding to cart silently wiped the whole configuration off the PDP. Restoring is
       * keyed on having a snapshot for this bid, which is the honest condition; a block
       * with nothing staged still returns below. */
      const bid = root.dataset.bid;
      const snap = consumed
        ? consumed.filter((b) => String(b && b.meta && b.meta.bid) === String(bid))
        : __lastStaged.get(String(bid));
      if (!snap || !snap.length) return;
      /* Fresh ids: the consumed bundle's id is gone, and reusing it would collide if the
       * customer stages again before this runs. */
      /* Re-stage the BUNDLE too, not just the charms. buy-buttons calls MPB's
       * getStagedLineItems() without peek, which CLEARS its map — correct when the page
       * is done with, wrong now that we keep the configuration. bundle-set-total then
       * recomputed against an empty map and the set's products contributed nothing, so
       * the total collapsed to the charm subtotal alone. __mpbRestage repopulates it from
       * the selections still on screen. */
      document.querySelectorAll('.mpb[data-bid]').forEach((el) => {
        if (typeof el.__mpbRestage === 'function') { try { el.__mpbRestage(); } catch (err) {} }
      });
      snap.forEach((b) => {
        try {
          window.CIKB.stageBundle({
            ...b,
            id: (crypto?.randomUUID?.() || String(Date.now()) + Math.random()),
            items: (b.items || []).map((it) => ({ ...it })),
            display: (b.display || []).map((d) => ({ ...d }))
          });
        } catch (err) {}
      });
    });
  });

  /* Colour picked in the charm modal drives the bundle's collar and leash.
   * charm-name-inline wires the same event, but only on templates running the inline
   * name field — in modal mode nothing was listening, so the sync went one way. */
  /* Bundle collar row -> the modal's own swatch row. Re-read on any click that lands on a
   * bundle swatch rather than holding a reference: the bundle rebuilds its rows on
   * selection, so a cached node is gone by the time this runs. */
  function collarLabelNow() {
    const sw = __bandSwatch();
    return sw ? (sw.getAttribute('aria-label') || '').trim() : '';
  }
  function pushCollarColourToModals() {
    const label = collarLabelNow();
    if (!label) return;
    document.querySelectorAll('.cikb[data-bid]').forEach((r) => {
      if (typeof r.__cikbSetColorByLabel === 'function') r.__cikbSetColorByLabel(label);
    });
  }
  /* Hand the collar's colour to the CART.
   *
   * product-block-buy-buttons reads mpbStrapHex / mpbStrapImg out of storage when it posts
   * the bundle, and the cart strip paints from the resulting line properties. Only
   * charm-name-inline was writing them, and only on templates running the inline name
   * field — so in modal mode the cart strip had no colour at all, and mpbStrapImg had no
   * writer anywhere, which is why a printed colourway never reached the cart.
   *
   * The 3D block claims ownership where it is on the page: it knows the real webbing hex,
   * where this resolves from a swatch and flattens a two-tone to one half. */
  function publishStrapToCart() {
    if (window.__strapHexOwner === 'c3d') return;
    const st = stagedStrapStyle();
    if (!st) return;
    try {
      if (st.color) sessionStorage.setItem('mpbStrapHex', st.color);
      /* Only a purpose-made strap tile travels to the cart. The cart tiles _StrapImg at the
       * pattern aspect, and a square colour chip forced into that ratio arrives compressed —
       * so for those, say nothing and let the cart resolve its own collar-pattern asset from
       * the line's colour, which it already knows how to do. */
      if (st.image && (st.tile === 'pattern' || st.tile === 'repeat')) sessionStorage.setItem('mpbStrapImg', st.image);
      else sessionStorage.removeItem('mpbStrapImg');
    } catch (e) {}
  }

  document.addEventListener('change', (e) => {
    if (e.target && e.target.closest && (e.target.closest('.mqb__free-select') || e.target.closest('.mqb__tier'))) {
      setTimeout(() => { publishStrapToCart(); repaintAllStagedStraps(); }, 40);
    }
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest) return;
    if (e.target.closest('.mpb-swatch') || e.target.closest('.mqb__swatch') || e.target.closest('.swatch')) {
      setTimeout(() => { pushCollarColourToModals(); publishStrapToCart(); repaintAllStagedStraps(); }, 40);
    }
    if (e.target.closest('[id^="cikb-open-"]')) setTimeout(pushCollarColourToModals, 60);
  });

  document.addEventListener('cikb:strapcolor', (e) => {
    const label = e.detail && e.detail.label;
    if (!label) return;
    /* Route by what is ON THE PAGE, not by which global happens to be defined. mpb.js
     * publishes window.MPB with a setColor on every product page whether or not a bundle
     * block is rendered, so testing for the global swallowed every colour change into a
     * no-op and the quantity bundle and the plain PDP never got a look in. */
    /* Route by what is ON THE PAGE, and prefer clicking the real control over calling an
     * API. mpb.js publishes window.MPB with a setColor on every product page whether or not
     * a bundle block is rendered, so testing for the global swallowed every colour change
     * into a no-op; and on the set templates colours are INDEPENDENT per component, so
     * __mpbSetColor has no appliers wired and setColor does nothing even where it is real.
     * Clicking the swatch the customer would have clicked works in every configuration. */
    const want = String(label).trim().toLowerCase();
    /* Select a swatch the way the control expects.
     *
     * The theme's own swatch is a `<button type="button">` inside a label wrapping the
     * variant radio, and the variant selector listens for `change` ON THE RADIO — a
     * programmatic .click() on the button does nothing at all. That is why picking a colour
     * in the modal moved nothing on a plain PDP: the event fired, the routing ran, and the
     * final step was a silent no-op. MQB and MPB swatches do bind click, so they still get
     * a click. */
    const activateSwatch = (n) => {
      const lab = n.closest && n.closest('label');
      const input = lab && lab.querySelector('input[js-variant-input], input[name="id"]');
      if (input) {
        if (!input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
      n.click();
    };
    const clickByLabel = (nodes) => {
      for (const n of nodes) {
        if ((n.getAttribute('aria-label') || '').trim().toLowerCase() !== want) continue;
        if (!n.classList.contains('is-active') && !n.classList.contains('swatch--selected')) activateSwatch(n);
        return true;
      }
      return false;
    };

    let handled = false;
    const unitIndex = (e.detail && e.detail.unitIndex) || 0;

    /* 1) Quantity bundle — but only when the open tier actually renders unit rows. On the
     * "Buy 1" tier MQB owns nothing visible: it would record the pick internally and write
     * the hidden id WITHOUT dispatching change (deliberately, so the theme does not re-render
     * and orphan the staged items), so the customer saw the selector never move. A single
     * unit follows the product's own colour selector, which is rule the page already uses
     * for the band. */
    const openTier = document.querySelector('.mqb__tier.is-selected');
    const tierHasUnits = !!(openTier && openTier.querySelector('.mqb__unit, .mqb__free'));
    if (tierHasUnits) {
      if (window.MQB && typeof window.MQB.setUnitColor === 'function') {
        handled = window.MQB.setUnitColor(unitIndex, label);
      }
      if (!handled) {
        const rows = Array.from(openTier.querySelectorAll('.mqb__unit, .mqb__free'));
        const row = rows.length ? rows[unitIndex % rows.length] : null;
        if (row) handled = clickByLabel(row.querySelectorAll('.mqb__swatch[aria-label]'));
      }
    }

    // 2) Set builder: the card the charms actually sit on, in the same order the band reads.
    if (!handled && document.querySelector('.mpb-card')) {
      const rows = [
        '.mpb-card[data-is-collar="true"] .mpb-swatch[aria-label]',
        '.mpb-shared-color .mpb-swatch[aria-label]',
        '.mpb-opt--color .mpb-swatch[aria-label]'
      ];
      for (const sel of rows) {
        if (clickByLabel(document.querySelectorAll(sel))) { handled = true; break; }
      }
      if (!handled && window.MPB && typeof window.MPB.setColor === 'function') {
        handled = !!window.MPB.setColor(label);
      }
    }

    // 3) Plain PDP: the product's own colour selector.
    if (!handled) {
      const scope = document.querySelector('[js-product-section]') || document;
      clickByLabel(scope.querySelectorAll('.option-group__swatches-container .swatch[aria-label]'));
    }
    setTimeout(repaintAllStagedStraps, 80);
  });

  /* Switching colour on the PDP has to move the staged band with it. A click listener is
   * not enough on its own: the theme REBUILDS its variant selector on change, so the node
   * that was clicked is gone by the time anything reads it back. The form's hidden id
   * input is the one thing that survives, which is the same signal the quantity bundle
   * watches for the same reason. */
  (function watchVariantForStrap() {
    const readId = () => {
      const el = document.querySelector('[data-product-form]:not(.visually-hidden) input[name="id"]')
              || document.querySelector('[data-product-form] input[name="id"]');
      return el ? String(el.value || '') : '';
    };
    let last = readId();
    setInterval(() => {
      const now = readId();
      if (!now || now === last) return;
      last = now;
      try { pushCollarColourToModals(); } catch (e) {}
      try { publishStrapToCart(); } catch (e) {}
      try { repaintAllStagedStraps(); } catch (e) {}
    }, 400);
  })();

  // ---------------- per-block init ----------------
  async function initBlock(root) {
    if (root.__cikbMounted) return;
    const bid = root.dataset.bid;
    if (!bid) return;
    root.__cikbMounted = true;

    const DATA = getPayload(bid);
    const pricePerCharm = parsePricePerCharm(DATA?.ui?.priceNote, 3);

    // elements
    const $ = id => document.getElementById(id);
    const el = {
      open:   $(`cikb-open-${bid}`),
      modal:  $(`cikb-modal-${bid}`),
      strap:  $(`cikb-strap-${bid}`),
      count:  $(`cikb-count-${bid}`),
      clear:  $(`cikb-clear-${bid}`),
      colors: $(`cikb-colors-${bid}`),
      keygrid:$(`cikb-keygrid-${bid}`),
      add:    $(`cikb-add-${bid}`),
    };
    if (!el.open || !el.modal) return;

    // ensure closed initially
    try { el.modal.removeAttribute("open"); } catch {}

    // push style variables from payload so theme colors “stick”
    applyStyleVars(el.modal, DATA?.styles || {});

    // per-block state
    const S = { strap: [], currentColorIndex: 0, editingId: null };
    const setCount = () => { if (el.count) el.count.textContent = String(S.strap.length); updateCTA(); };

    // listen for global staged changes to keep this block’s list in sync
    const onStageChange = () => { renderStagedList(root, bid, DATA); publishStrapToCart(); };
    /* The bundle builder rebuilds its swatches on selection, so re-paint on any click that
     * lands on one rather than holding a reference across the rebuild. */
    document.addEventListener('click', (e) => {
      if (e.target.closest && (e.target.closest('.mpb-swatch') || e.target.closest('.mqb__swatch') || e.target.closest('.swatch'))) {
        setTimeout(() => repaintAllStagedStraps(root), 40);
      }
    });
    document.addEventListener('cikb:staged:change', onStageChange);

    // ---------- open/close ----------
    function openModal() {
      /* Reopening a set that is already staged is an EDIT, not a new set. Single-set blocks
       * already relabel the button "Edit charms", but the modal still opened empty and the
       * customer had to retype the whole name. Load the staged charms back in, and replace
       * that bundle on save instead of stacking a second one beside it. */
      if (String(root.dataset.singleSet || '') === 'true' && !S.strap.length) {
        try {
          const mine = window.CIKB.getStagedBundles()
            .filter((b) => String(b && b.meta && b.meta.bid) === String(bid));
          const last = mine[mine.length - 1];
          const saved = last ? rebuildStrap(last) : null;
          if (saved && saved.length) {
            S.strap = saved;
            S.editingId = last.id;
            renderStrap(); setCount();
          }
        } catch (e) {}
      }
      /* Work out which unit this set belongs to BEFORE the colour row is built. The row's
       * tail restores from __cikbSeedLabel, so setting it afterwards is a frame too late —
       * the row came up on the previous set's colour and stayed there. */
      try {
        const mine0 = window.CIKB.getStagedBundles()
          .filter((b) => String(b && b.meta && b.meta.bid) === String(bid));
        const at0 = S.editingId
          ? mine0.findIndex((b) => String(b.id) === String(S.editingId))
          : -1;
        const seedIdx0 = at0 >= 0 ? at0 : mine0.length;
        const sw0 = __bandSwatch(seedIdx0);
        root.__cikbSeedLabel = sw0 ? (sw0.getAttribute('aria-label') || '').trim() : '';
      } catch (e) { root.__cikbSeedLabel = ''; }
      try { rebuildPreviewRow(); } catch (e) {}
      /* Point the modal at the unit THIS set sits on. A set being edited keeps its own
       * position, a new set takes the next one, and both wrap once there are more sets than
       * units. This used to run only when adding, so the modal kept whatever it was last
       * set to — and editing set 1 came up wearing set 2's colour. */
      try {
        const mine = window.CIKB.getStagedBundles()
          .filter((b) => String(b && b.meta && b.meta.bid) === String(bid));
        const at = S.editingId
          ? mine.findIndex((b) => String(b.id) === String(S.editingId))
          : -1;
        const idx = at >= 0 ? at : mine.length;
        const sw = __bandSwatch(idx);
        const label = sw ? (sw.getAttribute('aria-label') || '').trim() : '';
        if (label && typeof root.__cikbSetColorByLabel === 'function') {
          root.__cikbSetColorByLabel(label);
        }
        /* Remember it, then RE-APPLY as the row settles.
         *
         * The colour row rebuilds asynchronously after this runs, and the rebuild redefines
         * __cikbSetColorByLabel over a fresh set of nodes — so a single application here is
         * measurably correct at t+60ms and gone by t+300ms, which is exactly what opening
         * the builder for set 2 looked like: unit 2's colour for a frame, then unit 1's.
         * Re-applying on the next frame and twice more is cheap and idempotent, and it is
         * the honest fix while the row owns its own rebuild schedule. */
        root.__cikbSeedLabel = label || '';
        const reseed = () => {
          try {
            const want = String(root.__cikbSeedLabel || '');
            if (want && typeof root.__cikbSetColorByLabel === 'function') {
              root.__cikbSetColorByLabel(want);
            }
          } catch (e2) {}
        };
        try { requestAnimationFrame(reseed); } catch (e3) {}
        setTimeout(reseed, 150);
        setTimeout(reseed, 450);
        /* The modal's own colour row lists the seven standard colours and none of the
         * limited editions, so a Cherie unit matches nothing there and the preview would
         * stay stale. Paint the strap from the unit's real style either way. */
        const st = stagedStrapStyle(idx);
        if (st && el.modal) {
          /* The modal's strap fill is a ::before whose `background` shorthand IS this
           * variable, so an image has to arrive as a shorthand too — painting the bar
           * itself put it behind the pseudo-element, which is why an edit opened blank. */
          if (st.image) {
            el.modal.style.setProperty('--cikb-preview',
              'url("' + st.image + '") center / auto 100% repeat-x');
          } else if (st.color) {
            el.modal.style.setProperty('--cikb-preview', st.color);
          }
        }
      } catch (e) {}
      try {
        if (typeof el.modal.showModal === "function" && !el.modal.open) {
          el.modal.showModal();
        } else {
          el.modal.setAttribute("open","open");
        }
      } catch {
        el.modal.setAttribute("open","open");
      }
      el.modal.style.display = "grid";
      el.modal.style.position = "fixed";
      el.modal.style.zIndex = "9999";
      document.documentElement.style.overflow="hidden";
      document.body.style.overflow="hidden";
    }
    /* Load a staged set back into the editor and open it. Used by the Edit button on each
     * staged row; the single-set trigger takes the same path through openModal. */
    root.__cikbEditBundle = (bundleId) => {
      try {
        const b = window.CIKB.getStagedBundles().find((x) =>
          String(x.id) === String(bundleId) && String(x && x.meta && x.meta.bid) === String(bid));
        const saved = rebuildStrap(b);
        if (!b || !saved || !saved.length) return false;
        S.strap = saved;
        S.editingId = b.id;
        renderStrap(); setCount();
        openModal();
        return true;
      } catch (e) { return false; }
    };

    function closeModal() {
      /* Closing without saving leaves the staged bundle untouched, so drop the working copy
       * and let the next open read it back rather than showing a half-finished edit. */
      if (S.editingId) {
        S.editingId = null; S.strap = [];
        try { renderStrap(); setCount(); } catch (e) {}
      }
      try { if (el.modal.open) el.modal.close(); } catch {}
      el.modal.removeAttribute("open");
      el.modal.style.display = "";
      el.modal.style.position = "";
      el.modal.style.zIndex = "";
      document.documentElement.style.overflow="";
      document.body.style.overflow="";
    }

    // ---------- style vars ----------
    function applyStyleVars(scope, vars){
      if (!scope) return;
      const map = {
        surface:"--cikb-surface",
        card:"--cikb-card",
        border:"--cikb-border",
        strapBg:"--cikb-strap-bg",
        strapBorder:"--cikb-strap-border",
        chipBg:"--cikb-chip-bg",
        chipText:"--cikb-chip-text",
        heading:"--cikb-heading",
        body:"--cikb-body",
        keyBg:"--cikb-key-bg",
        keyBorder:"--cikb-key-border",
        keyLetter:"--cikb-key-letter",
        ctaBg:"--cikb-cta-bg",
        ctaText:"--cikb-cta-text",
        preview:"--cikb-preview"
      };
      Object.keys(map).forEach(k=>{
        if (vars[k]) scope.style.setProperty(map[k], vars[k]);
      });
    }

    // ---------- preview swatches (strap color) ----------
    function rebuildPreviewRow() {
      const row = el.modal && el.modal.querySelector('.cikb-preview-swatches');
      if (!row) return;
      const src = __pageColourSwatches();
      if (!src.length) return;
      row.innerHTML = '';
      src.forEach((node) => {
        const label = (node.getAttribute('aria-label') || '').trim();
        if (!label) return;
        const fill = node.querySelector('.mpb-swatch__fill') ||
                     node.querySelector('.swatch__inner') || node;
        const cs = getComputedStyle(fill);
        const sw = document.createElement('span');
        sw.className = 'sw';
        sw.setAttribute('data-label', label);
        sw.title = label;
        const bg = cs.backgroundColor;
        if (bg && bg !== 'rgba(0, 0, 0, 0)') sw.style.setProperty('--sw', bg);
        const m = String(cs.backgroundImage || '').match(/url\((['"]?)(.*?)\1\)/);
        if (m && m[2]) {
          sw.style.backgroundImage = 'url("' + m[2] + '")';
          sw.style.backgroundSize = 'cover';
          sw.style.backgroundPosition = 'center';
        }
        row.appendChild(sw);
      });
      bindPreviewSwatches();
    }

    function bindPreviewSwatches() {
      const row = el.modal.querySelector('.cikb-preview-swatches');
      if (!row) return;
      const nodes = Array.from(row.querySelectorAll('.sw'));
      const setActive = (idx) => nodes.forEach((n,i)=>n.classList.toggle('is-active', i===idx));
      /* The strap fill is a ::before whose `background` shorthand IS --cikb-preview, so a
       * printed colourway has to arrive as a shorthand. Those swatches carry no --sw at
       * all, so reading only the colour fell through to the block's default green. */
      /* A printed colourway has a purpose-cut REPEAT tile in Settings > Files, emitted as
       * window.CIKB_STRAP_TILES. It cannot be delivered through --cikb-preview: fed a
       * `background` shorthand the property hands the strap the colour every single time and
       * the image never, which is the whole reason Mediterranean read as a flat band here
       * while it tiled correctly on live. Write a real rule and beat the theme's own
       * `background:var(--cikb-preview) !important` on specificity with a leading html.
       *
       * `auto 100%` is right for THESE tiles specifically: they are true repeat units cut
       * from the vector artwork (Valencia 1.05:1, Milos 3.42:1), so their natural aspect is
       * the printed one. That is not true of the collar-pattern-*.png webbing tiles below,
       * which are 13.07mm by 25.05mm and are still sized against the strap's own height. */
      const __tileFor = (n) => {
        const m = window.CIKB_STRAP_TILES || {};
        const lbl = (n && n.getAttribute && (n.getAttribute('data-label') || n.getAttribute('aria-label'))) || '';
        return m[String(lbl).trim().toLowerCase()] || '';
      };
      const __writeStrapRule = (hex, tile) => {
        const sheetId = 'cikb-strap-fill-' + bid;
        let stEl = document.getElementById(sheetId);
        if (!stEl) { stEl = document.createElement('style'); stEl.id = sheetId; document.head.appendChild(stEl); }
        stEl.textContent =
          'html #cikb-' + bid + ' .cikb-strap__bar::before{'
          + 'background-color:' + (hex || '#47B276') + ' !important;'
          + 'background-image:' + (tile ? 'url("' + tile + '")' : 'none') + ' !important;'
          + 'background-size:auto 100% !important;'
          + 'background-repeat:repeat !important;'
          + 'background-position:left center !important;}';
      };

      const __paintPreview = (n) => {
        const st = __swatchStyle(n);
        const hex = (st && st.color) || getComputedStyle(n).getPropertyValue('--sw').trim();
        const tile = __tileFor(n);
        if (tile) {
          /* Solid first, artwork once it proves it loads -- a url() that 404s left the strap
           * transparent, so picking a colour looked like picking nothing. */
          __writeStrapRule(hex || DATA?.styles?.preview || '#47B276', '');
          el.modal.style.setProperty('--cikb-preview', hex || DATA?.styles?.preview || '#47B276');
          const tprobe = new Image();
          tprobe.onload = function () { __writeStrapRule(hex || '#47B276', tile); };
          tprobe.src = tile;
          return;
        }
        /* No purpose-cut tile: clear any rule this block wrote earlier, or a previously
         * chosen pattern stays painted under the next flat colour. */
        __writeStrapRule(hex || DATA?.styles?.preview || '#47B276', '');
        /* Paint the solid FIRST and swap to artwork only once it loads. Most colours ship no
         * strap tile — sky-green 404s — and setting a url() that never resolves left the
         * strap transparent, so picking Sky/Green looked like picking nothing. */
        el.modal.style.setProperty('--cikb-preview', hex || DATA?.styles?.preview || '#47B276');
        if (st && st.image) {
          const probe = new Image();
          probe.onload = function () {
            /* Tile at the strap's own aspect, not `auto 100%`. The tile is 13.07mm by
             * 25.05mm, so one is 0.52 of the height wide — stretching it to the full height
             * at natural width is what turned La Lune's dots into ovals. */
            const h = (el.strap && el.strap.getBoundingClientRect().height) || 60;
            const w = (h * 0.5217).toFixed(1);
            el.modal.style.setProperty('--cikb-preview',
              'url("' + st.image + '") center / ' + w + 'px ' + h.toFixed(1) + 'px repeat-x');
          };
          probe.src = st.image;
        }
      };
      /* The other direction: let the bundle's collar row drive this one, so opening the
       * modal shows the colour already chosen rather than resetting to the first swatch. */
      root.__cikbSetColorByLabel = (label) => {
        const want = String(label || '').trim().toLowerCase();
        if (!want) return false;
        for (let i = 0; i < nodes.length; i++) {
          /* data-label FIRST. The row is rebuilt from the page's own picker, so its order
            * no longer matches the seven static entries in the block settings — indexing
            * into those named the wrong colour, which is why adding a second set opened on
            * the first unit's colour and the modal could not send the right one back. */
          const lbl = (nodes[i].getAttribute('data-label') || (DATA?.swatches?.[i] || {}).label || '')
            .trim().toLowerCase();
          if (lbl && lbl === want) {
            __paintPreview(nodes[i]);
            setActive(i);
            return true;
          }
        }
        return false;
      };
      nodes.forEach((n,i)=>{
        n.addEventListener('click', ()=>{
          __paintPreview(n);
          setActive(i);
          /* Still reported to listeners even though __paintPreview owns the painting now:
           * dropping the declaration while leaving it in the detail threw a ReferenceError
           * BEFORE the dispatch, which killed the colour round-trip on every page type. */
          const hex = (__swatchStyle(n) || {}).color ||
                      getComputedStyle(n).getPropertyValue('--sw').trim();
          /* This row is the collar/leash colour, so tell the rest of the page. */
          const label = n.getAttribute('data-label') || (DATA?.swatches?.[i] || {}).label || '';
          /* Which unit this colour belongs to: the set being edited sits where it was
           * staged, a new set takes the next position. A quantity bundle needs this to
           * know WHICH leash the customer just recoloured. */
          let unitIndex = 0;
          try {
            const mine = window.CIKB.getStagedBundles()
              .filter((b) => String(b && b.meta && b.meta.bid) === String(bid));
            const at = S.editingId
              ? mine.findIndex((b) => String(b.id) === String(S.editingId))
              : -1;
            unitIndex = at >= 0 ? at : mine.length;
          } catch (e) {}
          document.dispatchEvent(new CustomEvent('cikb:strapcolor', {
            detail: { bid, index: i, hex, label, unitIndex }
          }));
        });
      });
      if (nodes.length) {
        /* Honour the seeded unit colour if the modal was opened for a particular set;
         * only fall back to the first swatch when there is nothing to restore. */
        let seedAt = 0;
        try {
          const want = String(root.__cikbSeedLabel || '').trim().toLowerCase();
          if (want) {
            const found = nodes.findIndex((n) => String(
              (n.getAttribute('data-label') || '')).trim().toLowerCase() === want);
            if (found >= 0) seedAt = found;
          }
        } catch (e) {}
        __paintPreview(nodes[seedAt]);
        setActive(seedAt);
      } else if (DATA?.styles?.preview) {
        el.modal.style.setProperty('--cikb-preview', DATA.styles.preview);
      }
    }

    // ---------- color pills ----------
    function bindColorPills(){
      if (!el.colors) return;
      const pills = Array.from(el.colors.querySelectorAll(".cikb-color"));
      const activate = (idx) => pills.forEach((b,i)=>b.classList.toggle('is-active', i===idx));
      pills.forEach((btn, idx)=>{
        btn.addEventListener("click", ()=>{
          S.currentColorIndex = idx;
          activate(idx);
          renderKeys();
        });
      });
      activate(0);
    }

    // ---------- render strap ----------
    function renderStrap(){
      if (!el.strap) return;
      el.strap.innerHTML = "";
      S.strap.forEach((it, i) => {
        const wrap = document.createElement("div");
        wrap.className = "cikb-strap__charm";

        const img = document.createElement("img");
        img.className = "cikb-strap__img";
        img.alt = it.title || "";
        img.src = it.img || "";
        /* Images are natively draggable, so without this the browser drags the picture
         * and the reorder drop never fires. The wrapper must be the drag source. */
        img.draggable = false;

        const rm  = document.createElement("button");
        rm.type = "button";
        rm.className = "cikb-strap__rm";
        rm.textContent = "×";
        rm.addEventListener("click", (ev)=>{ ev.preventDefault(); ev.stopPropagation(); S.strap.splice(i,1); renderStrap(); setCount(); });

        /* Drag to reorder, matching the inline builder. */
        wrap.draggable = true;
        wrap.dataset.idx = String(i);
        wrap.addEventListener("dragstart", (ev)=>{
          S.__dragFrom = i; wrap.classList.add("is-dragging");
          try { ev.dataTransfer.effectAllowed = "move"; ev.dataTransfer.setData("text/plain", String(i)); } catch(e){}
        });
        wrap.addEventListener("dragend", ()=>{
          S.__dragFrom = null;
          el.strap.querySelectorAll(".cikb-strap__charm").forEach(n=>n.classList.remove("is-dragging","is-drop-target"));
        });
        wrap.addEventListener("dragover", (ev)=>{
          if (S.__dragFrom == null) return;
          ev.preventDefault(); wrap.classList.add("is-drop-target");
        });
        wrap.addEventListener("dragleave", ()=> wrap.classList.remove("is-drop-target"));
        wrap.addEventListener("drop", (ev)=>{
          ev.preventDefault(); wrap.classList.remove("is-drop-target");
          const from = S.__dragFrom, to = i;
          S.__dragFrom = null;
          if (from == null || from === to) return;
          const [moved] = S.strap.splice(from, 1);
          S.strap.splice(to, 0, moved);
          renderStrap(); setCount();
        });

        wrap.addEventListener("pointerdown", (ev)=>{
          if (ev.pointerType === "mouse") return;
          S.__dragFrom = i; wrap.classList.add("is-dragging");
          const move = (e2)=>{
            const t = document.elementFromPoint(e2.clientX, e2.clientY);
            const hit = t && t.closest ? t.closest(".cikb-strap__charm") : null;
            el.strap.querySelectorAll(".cikb-strap__charm").forEach(n=>n.classList.remove("is-drop-target"));
            if (hit) hit.classList.add("is-drop-target");
          };
          const up = (e2)=>{
            document.removeEventListener("pointermove", move);
            document.removeEventListener("pointerup", up);
            const t = document.elementFromPoint(e2.clientX, e2.clientY);
            const hit = t && t.closest ? t.closest(".cikb-strap__charm") : null;
            wrap.classList.remove("is-dragging");
            el.strap.querySelectorAll(".cikb-strap__charm").forEach(n=>n.classList.remove("is-drop-target"));
            const from = S.__dragFrom;
            S.__dragFrom = null;
            if (!hit || from == null) return;
            const to = Number(hit.dataset.idx);
            if (Number.isNaN(to) || to === from) return;
            const [moved] = S.strap.splice(from, 1);
            S.strap.splice(to, 0, moved);
            renderStrap(); setCount();
          };
          document.addEventListener("pointermove", move);
          document.addEventListener("pointerup", up);
        });

        wrap.append(img, rm);
        el.strap.appendChild(wrap);
      });
    }

    // ---------- render keyboard ----------
    function renderKeys(){
      if (!el.keygrid) return;
      el.keygrid.innerHTML = "";

      const color = DATA.charms?.[S.currentColorIndex];
      if (!color) return;

      color.variants.forEach(v=>{
        const b = document.createElement("button");
        b.type = "button";
        b.className="cikb-key";

        // Sold out = variant unavailable (continue selling OFF + no stock) → block completely
        const isSoldOut = !v.available;
        // Preorder = variant available but inventory depleted (continue selling ON) → allow
        const isPreorder = v.available && (typeof v.qty === "number" && v.qty <= 0);

        if (isSoldOut) { b.classList.add("cikb-key--soldout"); }
        else if (isPreorder) { b.classList.add("cikb-key--oos"); }

        const box = document.createElement("div");
        box.className = "cikb-key__box";

        if (v.image) {
          const im = document.createElement("img");
          im.className = "cikb-key__img";
          im.alt = "";
          im.src = v.image;
          box.appendChild(im);
        } else {
          const tile = document.createElement("span");
          tile.className = "cikb-key__tile";
          tile.textContent = (v.title || "").slice(0,1).toUpperCase();
          box.appendChild(tile);
        }

        const cap = document.createElement("span");
        cap.className = "cikb-key__label";
        cap.textContent = v.title || "Variant";

        b.append(box, cap);

        // Sold out note (gray, blocked)
        if (isSoldOut) {
          const note = document.createElement("span");
          note.className = "cikb-key__soldout";
          note.textContent = "Out of stock";
          b.appendChild(note);
        }
        // Preorder note BELOW the image and label (red)
        else if (isPreorder) {
          const note = document.createElement("span");
          note.className = "cikb-key__preorder";
          note.textContent = DATA?.ui?.oosPreorderNote || " ";
          b.appendChild(note);
        }

        b.addEventListener("click", ()=>{
          // Block sold-out charms (continue selling OFF)
          if (isSoldOut) { return; }
          if (S.strap.length >= (DATA.maxChars||12)) { toast(DATA?.ui?.maxMsg || "Max charms reached"); return; }
          // Allow clicking when preorder (continue selling ON)
          S.strap.push({ variantId: v.id, freeVariantId: v.freeId || null,
                         title: v.title, img: v.image || "", oos: isPreorder });
          renderStrap(); setCount();
          ensureStrapEdgeScroll();
        });

        el.keygrid.appendChild(b);
      });
    }

    // Keep strap scrolled to the end as people add charms
    function ensureStrapEdgeScroll(){
      const bar = el.strap?.closest('.cikb-strap')?.querySelector('.cikb-strap__bar');
      if (!bar) return;
      requestAnimationFrame(()=>{ bar.scrollLeft = bar.scrollWidth; });
    }

    // ---------- CTA live price ----------
    function updateCTA(){
      if (!el.add) return;
      const count = S.strap.length;
      const total = count * pricePerCharm;
      let sub = el.add.querySelector(".cikb-cta__sub");
      if (!sub) {
        sub = document.createElement("span");
        sub.className = "cikb-cta__sub";
        el.add.appendChild(sub);
      }
      if (count > 0){
        sub.textContent = `${count} × ${moneyFmt(pricePerCharm)} = ${moneyFmt(total)}`;
      } else {
        sub.textContent = DATA?.ui?.ctaSub || "";
      }

      /* "$3 PER CHARM" is a typed setting, so it keeps saying $3 to a shopper paying in
       * another currency. Outside the shop's currency, show the converted price instead. */
      const noteEl = el.add.querySelector(".cikb-cta__price");
      if (noteEl) {
        if (!noteEl.dataset.cikbOriginal) noteEl.dataset.cikbOriginal = DATA?.ui?.priceNote || noteEl.textContent;
        noteEl.textContent = __presentmentRate() !== 1
          ? `${moneyFmt(pricePerCharm)} PER CHARM`
          : noteEl.dataset.cikbOriginal;
      }
    }

    // ---------- events ----------
    el.open.addEventListener("click", (e)=>{ e.preventDefault(); openModal(); });
    el.modal.querySelectorAll("[data-close]").forEach(b => b.addEventListener("click", closeModal));
    el.modal.addEventListener("cancel", (e)=>{ e.preventDefault(); closeModal(); });
    el.modal.addEventListener("click", (e)=>{ if (e.target === e.currentTarget) closeModal(); });

    el.clear?.addEventListener("click", ()=>{
      S.strap = []; renderStrap(); setCount();
      const bar = el.strap?.closest('.cikb-strap')?.querySelector('.cikb-strap__bar');
      if (bar) bar.scrollLeft = 0;
    });

    // ---------- Stage or Add-to-cart ----------
    el.add?.addEventListener("click", async ()=>{
      if (!S.strap.length) { alert(DATA?.ui?.pickOneMsg || "Pick at least one charm"); return; }

      // Notify debugging hooks if any
      try {
        const stagedDetail = { bid, strap: [...S.strap] };
        window.dispatchEvent(new CustomEvent("cikb:saved", { detail: stagedDetail }));
        document.dispatchEvent(new CustomEvent("cikb:saved", { detail: stagedDetail }));
      } catch {}

      const preorderNote = DATA?.ui?.oosPreorderNote || " ";

      if (DATA.stageOnly === true) {
        /* When the set gives charms away, stage the $0 twin variant instead of the
         * paid one so the line is genuinely free rather than discounted. Falls back
         * to the paid variant if no twin exists for that letter. */
        const freeMode = !!document.querySelector('[data-free-charms="true"]');

        // Build a UNIVERSAL bundle that Buy Buttons can later add with /cart/add.js
        const bundleId    = uuid();
        const bundleTitle = (DATA.bundleTitlePrefix || "Charms") + " — Bundle";

        const items = S.strap.map((ch, idx) => {
          const useFree = freeMode && ch.freeVariantId;
          return {
            id: String(useFree ? ch.freeVariantId : ch.variantId),
            quantity: 1,
            properties: {
              bundleId,
              bundleParentVariantId: DATA.parentVariantGid || "",
              bundleTitle,
              // Optional child attributes used by cart transform
              _Letter: (ch.title || "").trim(),
              _OrderIndex: String(idx),
              _IsPreorder: ch.oos ? "1" : "0",
              _PreorderNote: ch.oos ? preorderNote : "",
              ...(useFree ? { _FreeCharm: "1" } : {})
            }
          };
        });

        // Separate light display data (for thumbnails/labels in the staged UI)
        const display = S.strap.map(ch => ({ title: ch.title, img: ch.img || "", oos: !!ch.oos }));

        const stagedBundle = {
          id: bundleId,
          items,
          display,
          meta: {
            bid,
            count: items.length,
            pricePerCharm,
            bundleTitle,
            /* The working strap, kept so "Edit charms" can rebuild the modal exactly as the
             * customer left it. `display` is lossy -- it has no variant ids. */
            strap: S.strap.map((x) => ({ ...x }))
          }
        };

        /* An edit replaces the set where it stands; anything else is a new set. */
        if (S.editingId) {
          const was = S.editingId;
          S.editingId = null;
          window.CIKB.replaceBundle(was, stagedBundle);
        } else {
          window.CIKB.stageBundle(stagedBundle);
        }

        toast(DATA?.ui?.toastAdded || "Saved!");
        closeModal();

        // Reset working strap for next bundle
        S.strap = [];
        renderStrap(); setCount();
        return; // do NOT add to cart now
      }

      // Otherwise: add directly to cart now
      const freeModeDirect = !!document.querySelector('[data-free-charms="true"]');
      const directBundleId    = uuid();
      const directBundleTitle = (DATA.bundleTitlePrefix || "Charms") + " — Bundle";
      try {
        for (const [idx, ch] of S.strap.entries()){
          const f = new FormData();
          const useFreeDirect = freeModeDirect && ch.freeVariantId;
          f.append("id", String(useFreeDirect ? ch.freeVariantId : ch.variantId));
          f.append("quantity", "1");
          f.append("properties[bundleId]", directBundleId);
          f.append("properties[bundleParentVariantId]", DATA.parentVariantGid || "");
          f.append("properties[bundleTitle]", directBundleTitle);

          // Optional child attributes
          f.append("properties[_Letter]", (ch.title || "").trim());
          f.append("properties[_OrderIndex]", String(idx));
          if (useFreeDirect) f.append("properties[_FreeCharm]", "1");
          if (ch.oos) {
            f.append("properties[_IsPreorder]", "1");
            f.append("properties[_PreorderNote]", preorderNote);
          }

          const res = await fetch("/cart/add.js", { method:"POST", headers:{ "Accept":"application/json" }, body: f });
          if (!res.ok) throw new Error(await res.text());
        }
        toast(DATA?.ui?.toastAdded || "Bundle added!");
        closeModal();
        if (DATA.goToCart) location.href = "/cart";
        S.strap = [];
        renderStrap(); setCount();
      } catch (e){
        console.error("[cikb] add bundle failed:", e);
        alert(DATA?.ui?.toastError || "Add to cart failed. See console for details.");
      }
    });

    // ---------- boot ----------
    bindPreviewSwatches();
    bindColorPills();
    renderKeys();
    renderStrap();
    setCount();

    // First render (pull whatever is already staged for this block)
    renderStagedList(root, bid, DATA);

    // Optional: allow external open via event
    window.addEventListener('cikb:open', (ev) => {
      const targetBid = ev?.detail?.bid;
      if (String(targetBid) === String(bid)) openModal();
    });

    // expose for debugging
    window.__cikb = window.__cikb || {};
    window.__cikb[bid] = {
      open: openModal,
      close: closeModal,
      state: S,
      els: el,
      data: DATA,
      // used by the inline name builder to seed the modal with the current strap
      renderStrap,
      setCount
    };
  }
})();
